import { useContext, useEffect, useState } from "react";
import JunctionImage from "../../../images/ItemIcons/junction.svg";
import Refresh from "../../../images/ReOpen Ticket.svg";
import Working from "../../../images/dashboard/Working.svg";
import Notworking from "../../../images/dashboard/Not Working.svg";
import { useLazyQuery } from "@apollo/client";
import {
  AtsJunctionsOrderField,
  GetTransformNearByJunctionsResult,
  GetTransformNearByJunctionsVar,
} from "./queries/types";
import { GetTransformNearByJunctions } from "./queries/queries";
import { OrderDirection } from "../../../utils/commonQueryTypes";
import { TicketStatus } from "../../../utils/constants";
import { AppContext } from "../../../context/context";
import { payloadTypes } from "../../../context/reducer";
import { CustomDrawerInMobile } from "../../../styles/CustomDrawerStyles";
import FollowUpStatus from "./FollowUpStatus";
import RaiseTicket from "./RaiseTicket";
import LoadingModal from "../../pages/LoadingModal";

const SignalList = () => {
  const [getTransformNearByJunctions, { data, loading }] = useLazyQuery<
    GetTransformNearByJunctionsResult,
    GetTransformNearByJunctionsVar
  >(GetTransformNearByJunctions);
  const { state, dispatch } = useContext(AppContext);
  const [viewTicketDatails, setViewTicketDatails] = useState(false);
  const [raiseTicketDatails, setRaiseTicketDatails] = useState(false);

  useEffect(() => {
    if (state.customerId && state.latitude && state.longitude) {
      getTransformNearByJunctions({
        variables: {
          longitude: state.longitude,
          latitude: state.latitude,
          after: null,
          first: 25,
          orderBy: {
            direction: OrderDirection.DESC,
            field: AtsJunctionsOrderField.NAME,
          },
          name: "",
        },
      });
    }
  }, [
    getTransformNearByJunctions,
    state.customerId,
    state.latitude,
    state.longitude,
  ]);

  return (
    <>
      <div className="mobile-signals">
        <div className="mobile-signals__flex">
          <div className="mobile-signals__flex--image">
            <img src={JunctionImage} alt="" />
            <b>Near by Signals</b>
          </div>
          <div
            onClick={() => {
              window.location.reload();
            }}
            className="mobile-signals__flex--refresh"
          >
            <img src={Refresh} alt="" />
            <span>Refresh</span>
          </div>
        </div>
        <div className="mobile-signals__list">
          <ul>
            {data &&
              data.GetTransformNearByJunctions.edges.map(({ node }, index) => {
                return (
                  <li key={index}>
                    <div>
                      <div>{node.name}</div>
                      <div>({node.code})</div>
                    </div>

                    <div className="mobile-signals__list--button">
                      <img
                        src={
                          node.ticketStatus === TicketStatus.CLOSED
                            ? Working
                            : Notworking
                        }
                        alt=""
                      />
                      <button
                        onClick={() => {
                          dispatch({
                            type: payloadTypes.SET_JUNCTION_ID,
                            payload: {
                              junctionID: node.id,
                            },
                          });
                          if (node.ticketStatus === TicketStatus.CLOSED) {
                            setRaiseTicketDatails(true);
                          } else {
                            setViewTicketDatails(true);
                          }
                        }}
                      >
                        Choose
                      </button>
                    </div>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>

      <CustomDrawerInMobile
        anchor="bottom"
        open={viewTicketDatails}
        onClose={() => setViewTicketDatails(!viewTicketDatails)}
      >
        <FollowUpStatus setModal={setViewTicketDatails} />
      </CustomDrawerInMobile>
      <CustomDrawerInMobile
        anchor="bottom"
        open={raiseTicketDatails}
        onClose={() => setRaiseTicketDatails(!raiseTicketDatails)}
      >
        <RaiseTicket setModal={setRaiseTicketDatails} />
      </CustomDrawerInMobile>
      <LoadingModal flag={loading} message="Fetching..." forMobile={true} />
    </>
  );
};

export default SignalList;
